import React, { useState, useEffect } from "react";
import styles from "./Footer.module.css";

export default function Footer() {
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  useEffect(() => {
    function checkFooterVisibility() {
      const contentHeight = document.querySelector(".content").offsetHeight;
      const viewportHeight = window.innerHeight;
      const scrollPosition = window.pageYOffset;

      if (contentHeight - viewportHeight <= scrollPosition) {
        setIsFooterVisible(true);
      } else {
        setIsFooterVisible(false);
      }
    }

    window.addEventListener("scroll", checkFooterVisibility);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("scroll", checkFooterVisibility);
    };
  }, []);

  return (
    <footer
      className={`${styles.footer} ${isFooterVisible ? styles.show : ""}`}
    >
      &copy; {new Date().getFullYear()} Ng Yuen Ning. All rights reserved.
    </footer>
  );
}
